import { User, UserRole } from "../data/api";

export default function canActAsTechnician(user: User): boolean {
  if (!user.projectRoles) return false;
  const projectRoles = user.projectRoles.map((projectRole) => projectRole.role);
  return user.isAdmin || projectRoles.includes(UserRole.ProjectManager) || projectRoles.includes(UserRole.Tech);
}
